import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import "./footer.css";

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  // Scroll en haut de la page quand on arrive sur la page mentions légales
  useEffect(() => {
    if (location.pathname.includes("mentions-legales")) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.pathname]);

  const handleMentionsClick = (e) => {
    // Si on est déjà sur la page mentions légales, scroller en haut
    if (location.pathname.includes("mentions-legales")) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      // Sinon, naviguer vers la page et scroller en haut après un court délai
      navigate("/mentions-legales");
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
    }
  };

  return (
    <footer className="Footer">
      <p>
        2025 © Nice Plomberie. Tous droits réservés. Design by{" "}
        <a
          href="https://maelcorp.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          MaelCorp.
        </a>{" "}
      </p>
      <p>
        <Link to="/mentions-legales" onClick={handleMentionsClick}>
          Mentions Légales
        </Link>
      </p>
    </footer>
  );
}
